.section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.heading {
  font-size: 18px;
}

.empty {
  color: var(--ink-2);
}

/* An invitation waiting for an answer: accent-soft, like what is new. */
.banner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 14px 16px;
  border: var(--outline);
  border-radius: var(--radius-card);
  background: var(--accent-soft);
}

.lines {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.kind {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ink-2);
}

.who {
  font-size: 16px;
  font-weight: 700;
}

.detail {
  font-size: 13px;
  color: var(--ink-2);
}

.review {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  padding: 0 14px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--accent);
  box-shadow: var(--shadow-button);
  color: var(--accent-ink);
  font-size: 15px;
  font-weight: 700;
  text-decoration: none;
}
